module.exports = __webpack_public_path__ + "static/media/title.d5cb6eb3.png";